module.exports = __webpack_public_path__ + "img/Screen Shot 2020-10-28 at 9.53.39 AM.9fdca86b.png";